import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../Layout/Layout";
import ClientForm from "./ClientForm";
import ClientContract from "../Contracts/Contracts";
import Licenses from "../Licenses/Licenses";
import ClientUser from "./ClientUser";
import Financial from "../Financial/financial";
import { Button, Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "react-bootstrap-icons";
import { useTheme } from "../../Provider/Theme/themeContext";
import { useMediaQuery } from "react-responsive";

export default function ClientCad() {
    const [tabSelected, setTabSelected] = useState("tabClientForm");
    const { t } = useTranslation();
    const [contracts, setContracts] = useState([]);
    const { id } = useParams();
    const id_client = parseInt(id);
    const navigate = useNavigate();
    const { theme } = useTheme();
    const isMobile = useMediaQuery({ maxWidth: 767 });

    document.title = t(
        id ? "client.title-page.edit" : "client.title-page.create"
    );

    return (
        <Layout>
            {/* Cabeçalho customizado das abas + botão */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    margin: 10,
                    marginBottom: 0,
                    paddingRight: 10,
                    borderBottom:
                        theme === "dark"
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                }}
            >
                <Tabs
                    activeKey={tabSelected}
                    onSelect={(k) => setTabSelected(k)}
                    id="tab-client"
                    className="flex-grow-1"
                    style={{ borderBottom: "none" }}
                >
                    <Tab
                        eventKey="tabClientForm"
                        title={t("client.form.tab.form")}
                    />
                    <Tab
                        eventKey="tabClientContracts"
                        title={t("contract.tab.title")}
                        disabled={isNaN(id_client)}
                    />
                    <Tab
                        eventKey="tabClientLicenses"
                        title={t("licenses.tab.title")}
                        disabled={isNaN(id_client)}
                    />
                    <Tab
                        eventKey="tabClientUsers"
                        title={t("client.form.tab.user")}
                        disabled={isNaN(id_client)}
                    />
                    <Tab
                        eventKey="tabClientFinancial"
                        title={t("financial.tab.title")}
                        disabled={isNaN(id_client)}
                    />
                </Tabs>

                <Button
                    variant="outline-secondary"
                    onClick={() => navigate("/client")}
                    style={{ marginLeft: "auto", marginRight: 8 }}
                >
                    <ArrowLeft className="me-2" />
                    {t("client.actions.back")}
                </Button>
            </div>
            {/* Conteúdo das abas */}
            {tabSelected === "tabClientForm" && (
                <div
                    style={{
                        height: `calc(100vh - ${isMobile ? 180 : 110}px)`,
                        overflowY: "auto",
                    }}
                >
                    <ClientForm id={isNaN(id_client) ? null : id_client} />
                </div>
            )}
            {tabSelected === "tabClientContracts" && !isNaN(id_client) && (
                <div className="m-3">
                    <ClientContract
                        key={`contract-${id_client}`}
                        idClient={id_client}
                        listContracts={setContracts}
                    />
                </div>
            )}
            {tabSelected === "tabClientLicenses" && !isNaN(id_client) && (
                <div className="m-3">
                    <Licenses
                        key={`license-${id_client}`}
                        idClient={id_client}
                        contracts={contracts}
                    />
                </div>
            )}
            {tabSelected === "tabClientUsers" && !isNaN(id_client) && (
                <div className="m-3">
                    <ClientUser
                        key={`user-${id_client}`}
                        idClient={id_client}
                    />
                </div>
            )}
            {tabSelected === "tabClientFinancial" && !isNaN(id_client) && (
                <div 
                    className="m-3" 
                    style={{ 
                        maxWidth: '100%', 
                        overflow: 'hidden',
                        height: `calc(100vh - ${isMobile ? 180 : 110}px)`,
                        overflowY: 'auto'
                    }}
                >
                    <Financial
                        key={`financial-${id_client}`}
                        idClient={id_client}
                    />
                </div>
            )}
        </Layout>
    );
}
